export const GPT_HEAD_WHAT_IS_PAGE = `
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 330px)' },
  xxs: { size: 330, mq: '(min-width: 330px) and (max-width: 350px)' },
  xs: { size: 350, mq: '(min-width: 350px) and (max-width: 366px)' },
  sm: { size: 366, mq: '(min-width: 366px) and (max-width: 432px)' },
  md: { size: 432, mq: '(min-width: 432px) and (max-width: 672px)' },
  lg: { size: 672, mq: '(min-width: 672px) and (max-width: 758px)' },
  xl: { size: 758, mq: '(min-width: 758px) and (max-width: 1002px)' },
  xxl: { size: 1002, mq: '(min-width: 1002px) and (max-width: 1024px)' },
  xxxl: { size: 1024, mq: '(min-width: 1024px) and (max-width: 1267px)' }, // introduction of side menu
  xxxxl: {
    size: 1267,
    mq: '(min-width: 1267px) and (max-width: 1350px)',
  },
  xxxxxl: {
    size: 1350,
    mq: '(min-width: 1350px) and (max-width: 1660px)',
  },
  end: { size: 1660, mq: '(min-width: 1660px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
  leftRight: null,
  top: null,
  inContent: null,
  anchor: null,
  bottom: null,
}

googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xxxl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 100],
        [320, 50],
        [320, 180],
        [300, 100],
        [300, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the bottom
  sizeMapping.bottom = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 250],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // defining the main static slots
  googletag
    .defineSlot(
      '/22809915073/SingleCare_What-is/what-is-page_top',
      getAllAdSizes(sizeMapping.top),
      'div-gpt-ad-1686416451828-0'
    )
    .defineSizeMapping(sizeMapping.top)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_What-is/What-is-page_bottom',
      getAllAdSizes(sizeMapping.bottom),
      'div-gpt-ad-1686416681656-0'
    )
    .defineSizeMapping(sizeMapping.bottom)
    .addService(googletag.pubads())

  googletag
    .defineSlot(
      '/22809915073/SingleCare_What-is/What-is-page_bottom-anchor',
      getAllAdSizes(sizeMapping.anchor),
      'div-gpt-ad-1686416923171-0'
    )
    .defineSizeMapping(sizeMapping.anchor)
    .addService(googletag.pubads())

  // targeting variables
  // left this unchanged
  var seo_nameMeta = document.querySelector("meta[property='seo_name']")
  if (seo_nameMeta) {
    googletag
      .pubads()
      .setTargeting('seo_name', seo_nameMeta.content.slice(0, 40))
  }

  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  adSlotsBorder();
  googletag.enableServices()
});`;
